import React from 'react'

const FormInputTextarea = (props) => {
    const {label, error, onChange, onBlur, id, ...inputProps } = props;

return (
    <div className='form-group'>
        <label className='form-label mb-2'>
            {label}
        </label>
        <textarea 
            className='form-control' 
            style={{ 
                height: '150px',
                resize: 'vertical',
                minHeight: '120px'
            }} 
            {...inputProps} 
            onChange={onChange} 
            onBlur={onBlur}
        />
        {error && (
            <div className="form-error">
                {error}
            </div>
        )}
    </div>
)
}

export default FormInputTextarea